
import {Payload} from '../../../../../core/service/payload/payload';

export class CommunicationContentModelSavePayload implements Payload {
    label: string;
    typeValue: string;
    content: string;
    active: boolean;
}
